import React from "react";
import PageWrapper from "./common.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import RdUnitGoalTable from "../../components/report/RdUnitGoalTable";

const State = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.report"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.provider_unit_to_goal_report"
          }
        ]}
      />
      <div className="user-tbl">
        <RdUnitGoalTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(State);
